import { defineMessages } from 'react-intl';

export default defineMessages({
    enterCustomerInfo: {
        id: 'ml.gateway.common.newquote.Enter in the Customer\'s information to get started',
        defaultMessage: 'Enter in the Customer\'s information to get started'
    },
    newQuoteDOB: {
        id: 'ml.gateway.common.newquote.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    nextDescription: {
        id: 'ml.gateway.common.newquote.nextDescription',
        defaultMessage: 'Next, we\'ll {confirmTheCustomer}'
    },
    confirmTheCustomer: {
        id: 'ml.gateway.common.newquote.confirm the customer',
        defaultMessage: 'confirm the customer'
    },
    insuredAddress: {
        id: 'ml.gateway.common.newquote.Insured Address',
        defaultMessage: 'Insured Address'
    },
    enterStreetAddress: {
        id: 'ml.gateway.common.newquote.Enter street address (No PO Box)',
        defaultMessage: 'Enter street address (No PO Box)'
    },
    errorHeader: {
        id: 'ml.gateway.common.newquote.Error',
        defaultMessage: 'Error'
    },
    couldNotCreateAccount: {
        id: 'ml.gateway.common.newquote.Could not create the Account',
        defaultMessage: 'Could not create the Account'
    },
    errorRetrieveInfo: {
        id: 'ml.gateway.common.newquote.Error retrieving information, Please contact your Administrator',
        defaultMessage: 'Error retrieving information, Please contact your Administrator'
    }
});